module.exports = __webpack_public_path__ + "img/0381c6f66d32365e0550e5dafb130b21.png";